export default "__VITE_ASSET__d5db82b7__"